import type { PrivacyRequestListParams } from '../api/privacy-requests-api';

/** Store-scoped keys: switching stores never shares cache. */
export const privacyRequestKeys = {
  all: (storeId: string) => ['stores', storeId, 'privacy-requests'] as const,
  lists: (storeId: string) => [...privacyRequestKeys.all(storeId), 'list'] as const,
  list: (storeId: string, params: PrivacyRequestListParams) =>
    [...privacyRequestKeys.lists(storeId), params] as const,
};
